import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="role"
export default class extends Controller {
  static targets = [ "role" ]

  connect() {
  }

  toggle(e) {
    if (e.target.checked) {
      this.roleTarget.classList.add("bg-gray-50");
      this.roleTarget.disabled = true;
    } else {
      this.roleTarget.classList.remove("bg-gray-50");
      this.roleTarget.disabled = false;
    }
  }
}
